module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_HR-8bf8c9b03056f6e549f64b38db27195b.svg";